import React from 'react';
import {Amplify} from 'aws-amplify'; 
import awsconfig from './aws-exports'; 
import { Authenticator, withAuthenticator, signOut, ThemeProvider } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import theme from './theme';  // import the theme



Amplify.configure(awsconfig);

const Cognito = ({ signOut, user }) => {
    return (
      <div>
<ThemeProvider theme={theme} colorMode="light">
      <main>
          <div>
            <img 
              src="https://placehold.co/600x400/214DB0/FFF" 
              alt="placeholder"
              className="image" 
            />
          </div>
     
        </main>
        </ThemeProvider>
      </div>
    );
  }

export default withAuthenticator(Cognito);